'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, User, UserCheck } from '@sprd/sprd-component-kit/v2';
import { useState } from 'react';
import { useAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { LoginDialog, LoginWrapperProps } from '@/components/Header/LoginDialog';
import { userSessionAtom } from '@/store/atoms';
import { logout } from '@/utility/loginHelpers';
export const LoginButton = t0 => {
  const $ = _c(25);
  const {
    subDomain,
    sprdAccountsContext
  } = t0;
  const t = useTranslations();
  const [userSession, setUserSession] = useAtom(userSessionAtom);
  const [openLogin, setOpenLogin] = useState(false);
  let t1;
  if ($[0] !== setUserSession) {
    t1 = () => {
      logout().then(loggedOut => {
        if (loggedOut) {
          setUserSession(null);
        }
      });
    };
    $[0] = setUserSession;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLogout = t1;
  let t2;
  if ($[2] !== handleLogout || $[3] !== userSession) {
    t2 = userSession ? handleLogout : () => setOpenLogin(true);
    $[2] = handleLogout;
    $[3] = userSession;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== userSession) {
    t3 = userSession ? <UserCheck className="size-6" /> : <User className="size-6" />;
    $[5] = userSession;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t || $[8] !== userSession) {
    t4 = userSession ? t("userMenu.logout") : t("userMenu.login");
    $[7] = t;
    $[8] = userSession;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="text-base">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <Button variant="plain" onClick={t2}>{t3}{t5}</Button>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = open => setOpenLogin(open);
    t8 = () => setOpenLogin(false);
    $[16] = t7;
    $[17] = t8;
  } else {
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[18] !== openLogin || $[19] !== sprdAccountsContext || $[20] !== subDomain) {
    t9 = <LoginDialog open={openLogin} subDomain={subDomain} sprdAccountsContext={sprdAccountsContext} onOpenChange={t7} onLoginSuccess={t8} />;
    $[18] = openLogin;
    $[19] = sprdAccountsContext;
    $[20] = subDomain;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t6 || $[23] !== t9) {
    t10 = <>{t6}{t9}</>;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};